module.exports = __webpack_public_path__ + "static/img/team-build-04.004c936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-04.jpg
// module id = QXNl
// module chunks = 1